import {jwtDecode} from "jwt-decode";

export function saveToken(token) {
    localStorage.setItem('crm_token', token)
    const decoded = jwtDecode(token);
    const crmExpire = decoded.exp * 1000
    localStorage.setItem('crm_expire', crmExpire.toString())
}

export function saveTokenFromResponse(data) {
    saveToken(data.token)
}

export function clearLocalStorage() {
    localStorage.clear()
}


export const casinoBrands =
    [
        {
            "uuid": "be3585ef-dfe9-4410-aaa1-74503c85513b",
            "name": "SuperCat"
        },
        {
            "uuid": "f1585526-c2a4-4d9a-aef6-395ea2fef2ee",
            "name": "Slottica"
        },
        {
            "uuid": "a35c19f1-8631-41fc-b087-cb3d91dee4d5",
            "name": "Luckybirdcasino"
        },
        {
            "uuid": "fbcdf806-59d5-4a22-9b52-66030a327729",
            "name": "Allrightcasino"
        },
        {
            "uuid": "95062070-d228-4e78-8923-e30d51281db6",
            "name": "Spinamba"
        },
        {
            "uuid": "8bb2e8f6-d389-4804-942d-49c6f24ee5c7",
            "name": "Fortuneclock"
        },
        {
            "uuid": "b5eb4c6a-5a26-4745-b222-b12619a86a5d",
            "name": "Slottyway"
        },
        {
            "uuid": "9e3d80d0-cb4f-4424-b900-030da9b4275c",
            "name": "Patcasino"
        },
        {
            "uuid": "22286b14-591b-40f8-ac77-a2bc49cebda6",
            "name": "Magic365"
        },
        {
            "uuid": "19fd46d6-ce86-4f3e-984b-94c450d89126",
            "name": "Viks"
        },
        {
            "uuid": "b0da430a-ae9e-472b-b358-1e86295783b6",
            "name": "Spinbounty"
        },
        {
            "uuid": "c309b7ac-d822-4d85-803b-50cd002f6193",
            "name": "Spinado"
        },
    ]
